<template>
	<div v-show="isRangePicker">
		<div class="overlay" @click="showPicker(false)"></div>
		<div class="range">
			<date-picker :disabled="range" :inline="true" language="ru" @selected="update"></date-picker>

			<button v-show="dirty" class="next" @click="clear">Сбросить</button>
			<button v-show="selected" class="next" @click="save">Сохранить</button>
		</div>

	</div>
</template>

<script>
	import DatePicker from 'vuejs-datepicker'
	import moment from 'moment'

	export default {
		name: "RangePickerModal",
		components: {DatePicker},
		computed: {
			selected() {
				return !!this.range.to && !!this.range.from
			},
			dirty() {
				return !!this.range.to || !!this.range.from
			}
		},
		mounted() {
			this.$event.connect('openRangePicker', () => this.showPicker(true))
			this.$event.connect('closeRangePicker', () => this.showPicker(false))
		},
		beforeDestroy() {
			this.$event.disconnect(['openRangePicker', 'closeRangePicker'])
		},
		data() {
			return {
				isRangePicker: false,
				range: {
					from: null,
					to: null
				}
			}
		},
		methods: {
			showPicker(bool) {
				this.isRangePicker = bool
				this.range = {
					from: null,
					to: null
				}
			},
			update(day) {

				if (!this.range.to) {
					this.range.to = day
				} else if (!this.range.from) {
					this.range.from = day
				}
			},
			clear() {
				this.range = {
					from: null,
					to: null
				}
			},
			save() {
				if (!this.range.from || !this.range.to) {
					this.$event.toast('i', 'Выберите диапазон дат')
					return false
				}

				function _convert(date) {
					return moment(date).format('YYYY-MM-DD')
				}

				this.$event.send('saveSpecialRange', _convert(this.range.to) + ' - ' + _convert(this.range.from))
				this.showPicker(false)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.range {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 510;

		& > .next {
			background: white;
			margin-top: 20px;
			padding: 5px;
			outline: none;

			&:hover {
				background: #C7F1FF;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// RangePickerModal.vue?4e5ecc95